import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from '@/shadcn_components/ui/dialog';
import {UseDialogStateReturn} from '@/hooks/useDialogState';
import {Button} from '@/shadcn_components/ui/button';

type ConfirmDialogProps = {
  dialogState: UseDialogStateReturn;
  title?: string;
  content?: string;
  onConfirm?: () => void;
};

export const ConfirmDialog = ({dialogState, title, content, onConfirm}: ConfirmDialogProps) => {
  return (
    <Dialog open={dialogState.open} onOpenChange={dialogState.setOpen}>
      <DialogContent>
        <DialogTitle>{title || `Xác nhận?`}</DialogTitle>
        <DialogDescription>{content || `Thực hiện?`}</DialogDescription>
        <DialogFooter>
          <Button
            variant="ghost"
            onClick={e => {
              e.stopPropagation();
              dialogState.closeDialog();
            }}
            className="mr-1">
            <span>Không</span>
          </Button>
          <Button
            variant="destructive"
            onClick={e => {
              e.stopPropagation();
              onConfirm?.();
              dialogState.closeDialog();
            }}>
            <span>Có</span>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
